module.exports = __webpack_public_path__ + "static/media/tip4.3407a9ad.svg";